module.exports = __webpack_public_path__ + "static/media/crashed-car-web.381ad28e.webp";